import React from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Typography } from "@mui/material";
import { Employee } from "../../types/Employee";

export const NotificationEmployeeHeading = (props: { employee: Employee }) => {
  const { employee } = props;

  return (
    <ListItem disablePadding sx={{ flexGrow: 1 }}>
      <ListItemAvatar>
        <Avatar alt={employee.name} src={employee.picture} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography sx={{ fontWeight: 700, lineHeight: 'normal', mt: 0.4 }}>
            {employee.name}
          </Typography>
        }
        secondary={
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, lineHeight: 'normal' }}>
            {employee.idNumber}
          </Typography>
        }
      />
    </ListItem>
  )
}